import Spacer, { SpacerProps } from '../blocks/core/Spacer/Spacer'

export const renderSpacer = (spacer: SpacerProps) => spacer && <Spacer {...spacer} />
